import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./recommendations.scss";

const recommendations = [
  { badge: "eSIM", title: "Japan", subtitle: "Travel eSIM", href: "/esim?locationType=local&location=JP", image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=600&q=80" },
  { badge: "Flight", title: "Singapore to Tokyo", subtitle: "Flights", href: "/flights", image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=600&q=80" },
  { badge: "Experience", title: "Things to Do", subtitle: "Tours & attractions", href: "/things-to-do", image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?auto=format&fit=crop&w=600&q=80" },
  { badge: "Lounge", title: "Airport Lounge", subtitle: "Relax before takeoff", href: "/airport-lounges", image: "https://images.unsplash.com/photo-1516600164266-f3b8166ae679?auto=format&fit=crop&w=600&q=80" },
  { badge: "eSIM", title: "Bali", subtitle: "Travel eSIM", href: "/esim?locationType=local&location=ID", image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=600&q=80" },
];

const trackRecommendationClick = (item) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "recommendation_click", { recommendation_type: item.badge, label: item.title });
  }
};

export default function Recommendations() {
  return (
    <section className="teleport-section app-recommendations" aria-labelledby="recommendations-title">
      <div className="app-recommendations__heading">
        <div>
          <h2 id="recommendations-title">Recommendations</h2>
        </div>
        <Link to="/guides" className="teleport-secondary-button">View more <ArrowRight size={17} /></Link>
      </div>
      <div className="app-recommendations__rail">
        {recommendations.map((item) => (
          <Link to={item.href} className="recommendation-card" key={`${item.badge}-${item.title}`} onClick={() => trackRecommendationClick(item)}>
            <img src={item.image} alt="" loading="lazy" decoding="async" />
            <div className="recommendation-card__scrim" />
            <span className="recommendation-card__badge">{item.badge}</span>
            <div className="recommendation-card__copy"><h3>{item.title}</h3><p>{item.subtitle}</p></div>
          </Link>
        ))}
      </div>
    </section>
  );
}
